import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleAnalyticsService } from './admin/services/google-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(
    private router: Router,
    private gaService: GoogleAnalyticsService
	) { }
  
  ngOnInit() {
    // Disable route reuse
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.gaService.sendPageView(evt.urlAfterRedirects);

        if (this.router.url === '/notification') {
          this.router.navigated = false;
        }

        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts